/**
 * True when the frontend runs inside the Swile native app webview, detected via the
 * bridges the mobile projects inject (JSBridge on Android, window.webkit on iOS).
 *
 * Used to let the device/app locale (navigator.language) win over the Directory
 * account language in a webview — see useDirectoryLocaleSync.
 */
export const isMobileApp = (): boolean => {
  // @ts-expect-error 👌 JSBridge is injected by android project
  const hasAndroidBridge = typeof JSBridge !== 'undefined'
  const hasIOSBridge =
    // @ts-expect-error 👌 window.webkit is injected by iOS project
    typeof window?.webkit?.messageHandlers?.webViewMessageHandler?.postMessage !== 'undefined'
  return hasAndroidBridge || hasIOSBridge
}

export const notifyWebviewLoaded = () => {
  // @ts-expect-error 👌 JSBridge is injected by android project
  if (typeof JSBridge !== 'undefined' && typeof JSBridge?.webviewIsLoaded === 'function') {
    // @ts-expect-error 👌 JSBridge is injected by android project
    JSBridge.webviewIsLoaded()
  }

  // @ts-expect-error 👌 window.webkit is injected by iOS project
  if (typeof window?.webkit?.messageHandlers?.webViewMessageHandler?.postMessage !== 'undefined') {
    // @ts-expect-error 👌 window.webkit is injected by iOS project
    window.webkit.messageHandlers.webViewMessageHandler.postMessage('webviewIsLoaded')
  }
}
